// @ts-expect-error Untyped Dependency
import { getAnyCompanyLogo } from 'conversations-internal-schema/chat-heading-config/operators/getAnyCompanyLogo';
// @ts-expect-error Untyped Dependency
import { getAnyCustomChatName } from 'conversations-internal-schema/chat-heading-config/operators/getAnyCustomChatName';
// @ts-expect-error Untyped Dependency
import { isFromBot } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { getIsResponderAI } from 'conversations-internal-schema/responders/operators/responderGetters';
import { List as ImmutableList } from 'immutable';
import styled from 'styled-components';
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import SenderAvatar from '../sender-avatar/SenderAvatar';
import { getCompanyAsSender } from './operators/getCompanyAsSender';
import { getResponderAsSender } from './operators/getResponderAsSender';
import { jsx as _jsx } from "react/jsx-runtime";
const MultiAvatarWrapper = styled.div.withConfig({
  displayName: "InitialMessageAvatar__MultiAvatarWrapper"
})(["width:100%;height:100%;display:flex;justify-content:center;flex-wrap:wrap;margin-right:4px;margin-left:-4px;& > *{flex:1;line-height:1;position:relative;& > *{position:absolute;left:0;bottom:-8px;}div{background-color:white;}}"]);

/**
 * Our avatar data exists in two locations: first: in the chat heading configuration as a record
 * and second: in the widget data response. However, we only care about the chat heading
 * configuration when the configuration pertains to a custom company name and avatar link. Since
 * this information is not represented as a Responder, it doesn't get populated in the widget data.
 *
 * The `sendFrom` list that we get back in widget data is the more important of the two; we use
 * that list to check for valid sender avatars first. This list contains several responder records
 * which include an `avatar` field that we use to grab the avatar image URL. When the chatflow is
 * configured with a custom company name and avatar, the `sendFrom` list is empty.
 *
 * We ignore the `sendFrom` list in the cases where it is empty and attempt to pull in avatar
 * information from the chat heading configuration instead. Either the chat heading configuration
 * is a company or an owner. The former means that we get a `companyLogoUrl` and `customChatName`
 * in the chat heading config. The latter will contain a `fallback` which may contain either the
 * custom company information OR a list of team and user IDs that we have to parse against our map
 * of senders.
 */

const toSenderWithMeta = (sender, isResponderAI = false) => ({
  sender,
  isResponderAI
});
function getSenderAvatars({
  chatHeadingConfig,
  sender,
  sendFromResponders
}) {
  if (isFromBot(sender)) {
    return ImmutableList([toSenderWithMeta(sender)]);
  }
  if (sendFromResponders.size) {
    return sendFromResponders.map(responder => toSenderWithMeta(getResponderAsSender(responder), !!getIsResponderAI(responder))).toList();
  }
  const companyLogo = getAnyCompanyLogo(chatHeadingConfig);
  if (companyLogo) {
    return ImmutableList([toSenderWithMeta(getCompanyAsSender({
      companyLogo,
      customChatName: getAnyCustomChatName(chatHeadingConfig)
    }))]);
  }
  return ImmutableList();
}
function InitialMessageAvatar(props) {
  const avatars = getSenderAvatars(props);
  let avatarsContent;
  if (!avatars.size) {
    avatarsContent = /*#__PURE__*/_jsx(SenderAvatar, {
      isLoading: false
    });
  } else if (avatars.size === 1) {
    const {
      sender,
      isResponderAI
    } = avatars.get(0);
    avatarsContent = /*#__PURE__*/_jsx(SenderAvatar, {
      isLoading: false,
      sender: sender,
      isResponderAI: isResponderAI
    });
  } else {
    const twoAvatars = avatars.size === 2;
    avatarsContent = /*#__PURE__*/_jsx(MultiAvatarWrapper, {
      children: avatars.map(({
        sender,
        isResponderAI
      }, index) => /*#__PURE__*/_jsx(SenderAvatar, {
        isLoading: false,
        sender: sender,
        isResponderAI: isResponderAI,
        size: twoAvatars ? 'xs' : 'xxs'
      }, index))
    });
  }
  return /*#__PURE__*/_jsx(PrimaryMessageAvatar, {
    children: avatarsContent
  });
}
InitialMessageAvatar.displayName = 'InitialMessageAvatar';
export default InitialMessageAvatar;